$(document).ready(function() {
    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        on: {
            slideChange: function () {
                // Get the current active slide index within the looped range
                var activeIndex = this.realIndex; // Use realIndex to get the current slide index

                // Normalize the activeIndex to ensure it stays within the range of slides (0, 1, 2)
                var normalizedIndex = activeIndex % 3;
                if (normalizedIndex < 0) {
                    normalizedIndex += 3; // Handle negative values (e.g., if realIndex is -1)
                }

                // Update the active dot based on the normalized index
                $('.dot').removeClass('active');
                $('.dot[data-index="' + normalizedIndex + '"]').addClass('active');
            }
        }
    });
});
